@import "~@swisscom/sdx/stylesheets/sdx/variables/colors";
@import "~@swisscom/sdx/stylesheets/sdx/variables/sizes";
@import "~@swisscom/sdx/stylesheets/sdx/variables/grid";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/breakpoints";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/mediaqueries";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/typography";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/text";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/misc";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/core";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/gradient";
@import "~@swisscom/sdx/stylesheets/sdx/mixins/button";
@import "~@swisscom/sdx/stylesheets/sdx/variables/global";
@import "~@swisscom/sdx/stylesheets/sdx/button/button";
@import "~@swisscom/sdx/stylesheets/sdx/images/images";
@import "~@swisscom/sdx/stylesheets/sdx/link/link";
@import "~@swisscom/sdx/stylesheets/sdx/typography/typography";
@import "~@swisscom/sdx/stylesheets/sdx/css-variables-tokens-desktop";
@import "~@swisscom/sdx/stylesheets/sdx/css-variables-tokens-functional-and-mobile";

:host {
  --gradient-angle-0: 0deg;
  --gradient-angle-90: 90deg;
  --gradient-angle-180: 180deg;
  --gradient-angle-270: 270deg;
  --gradient-stops:
    #262626 0%, rgba(38, 38, 38, 0.5) 35%, rgba(38, 38, 38, 0) 70%;
}

.fc-wrapper {
  width: 100%;
  height: 504px; // Having this at '100%' made the AEM integration annoying, as it seems that there is no AEM container that would allow for fixed width/height (px) values. It's still in alignment with current design prototype, where all cards are 504 px high and also it's approved by UX like that.
  perspective: 1000px;
  color: $color-white;
  cursor: pointer;
  box-sizing: border-box;
}

.fc-card {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.6s;
}

.fc-card.fc-flipped {
  transform: rotateY(180deg);
}

.fc-frontside,
.fc-backside {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden; /* Safari support */
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.fc-frontside {
  display: flex;
  background-color: $color-white;
  z-index: 2;

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  transform: rotateY(0deg);
}

.fc-frontside-box {
  padding: 24px;
  border-radius: 16px;
  height: 100%;
}

.fc-frontside-gradient {
  background: linear-gradient(var(--gradient-angle-0), var(--gradient-stops));
}

.fc-frontside-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  h3 {
    margin: 0;
    text-align: center;
    font-weight: 400;
    color: var(--sdx-color-sc-white);
  }

  h2 {
    text-align: center;
    margin: 16px 0 48px;
    color: var(--sdx-color-sc-white);
  }

  .sc-navy {
    color: var(--sdx-color-sc-navy);
  }

  &.fc-align-text-bottom {
    justify-content: flex-end;
    align-items: center;
  }
}

.fc-info-icon {
  position: absolute;
  right: 24px;
  bottom: 24px;
  color: inherit;
}

.fc-info-icon:hover {
  background: $color-int-blue--active;
  border-radius: var(--sdx-border-radius-xlarge);
}

.fc-gradient-position {
  &-left {
    .fc-frontside-gradient {
      background: linear-gradient(
        var(--gradient-angle-90),
        var(--gradient-stops)
      );
    }
  }
  &-top {
    .fc-frontside-gradient {
      background: linear-gradient(
        var(--gradient-angle-180),
        var(--gradient-stops)
      );
    }
  }
  &-right {
    .fc-frontside-gradient {
      background: linear-gradient(
        var(--gradient-angle-270),
        var(--gradient-stops)
      );
    }
  }
}

.fc-backside {
  background-color: #fff;
  transform: rotateY(180deg);

  &-container {
    box-sizing: border-box;
    color: #000;
    padding: 24px;
  }

  h3 {
    margin: 0;
    margin-bottom: 16px;
    margin-top: 48px;
  }

  p {
    margin: 0;
    margin-bottom: 16px;
  }

  .fc-unflip-button {
    position: absolute;
    top: 24px;
    right: 24px;
  }
}
